<template>
  <c-container fluid class="d-flex content-center min-vh-100 login-container c-app c-dark-theme">
    <logo-long-boss />
    <c-row>
      <c-col>
        <c-card-group>
          <c-card class="p-4 login-form">
            <c-card-body>
              <c-alert show color="warning" v-if="error" close-button class="mt-4">
                {{ error }}
              </c-alert>
              <p v-if="loading" class="lead">
                Downloading your file
                <CSpinner color="success" size="sm"/>
              </p>
              <p v-else class="lead">
                Done!
              </p>
            </c-card-body>
          </c-card>
        </c-card-group>
      </c-col>
    </c-row>
  </c-container>
</template>

<script>
import _ from 'lodash';
import LogoLongBoss from '@/views/components/images/long-boss';
import { buildEndpoint } from '@/libs/buildEndPoint';

export default {
  name: 'DownloadBackup',
  components: { LogoLongBoss },
  data() {
    return {
      loading: false,
      signedDownloadUrl: null,
      error: null,
    };
  },
  computed: {
    downloadId() {
      return this.$route.params.downloadId;
    },
  },
  mounted() {
    this.getDownload();
  },
  methods: {
    getDownload() {
      this.loading = true;
      setTimeout(() => {
        this.$http
          .get(buildEndpoint(`site/backups/download/${this.downloadId}`))
          .then((response) => {
            if (!response.data.success) {
              this.error = response.data.message;
            }
            this.signedDownloadUrl = _.get(response, 'data.data.s3Url');
            window.location = this.signedDownloadUrl;
          })
          .catch((error) => {
            this.error = error.response.data.message;
          })
          .finally(() => {
            this.loading = false;
          });
      }, 3000);
    },
  },
};
</script>

<style lang="scss"></style>
